import * as React from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

export {useQueryClient} from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
    },
  },
});

export function Provider({children}: {children: React.ReactNode}): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
